<template>
  <v-container style="max-width: 1800px !important">
    <v-alert-dialog ref="alert" />

    <div class="pa-3">
      <v-row>
        <v-col cols="3">
          <v-text-field v-model.lazy="search.codigoEmpleado" label="Código de empleado" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="2">
          <v-text-field v-model.lazy="search.nombre" label="Nombre" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="2">
          <v-text-field v-model.lazy="search.apellidoPaterno" label="Apellido Paterno" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="2">
          <v-text-field v-model.lazy="search.apellidoMaterno" label="Apellido Materno" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model.lazy="search.rfc" label="RFC" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="10" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="3">
              <v-autocomplete v-model="search.tipoPuestos" :items="areas" item-value="id_rh_area" item-text="nombre" label="Tipos de Puestos" outlined dense hide-details multiple chips deletable-chips clearable @change="search.puestos = []" />
            </v-col>
            <v-col cols="3">
              <v-autocomplete v-model="search.puestos" :items="puestosFiltrados" item-value="id_puesto" item-text="nombre" label="Puestos" outlined dense hide-details multiple chips deletable-chips clearable />
            </v-col>
            <v-col cols="3">
              <v-select v-model="search.genero" :items="generos" item-value="value" item-text="text" label="Género" clearable dense hide-details outlined />
            </v-col>
            <v-col cols="3">
              <v-select v-model="search.anio" :items="years" label="Año" clearable dense hide-details outlined />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-btn block color="primary" text outlined :loading="loading" :disabled="loading" @click="getItems">
            <v-icon>mdi-magnify</v-icon>Buscar
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" item-key="id_empleado_puesto" show-select checkbox-color="primary" class="mt-4">
        <template v-slot:[`item.nombre_completo`]="{ item }">
          {{ nombreCompleto(item) }}
        </template>
        <template v-slot:[`item.periodo`]="{ item }">
          {{ periodo(item) }}
        </template>
        <template v-slot:[`item.acciones`]="{ item }">
          <v-tooltip bottom color="black">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click="abrirDialogo([item])">
                <v-icon small>mdi-file-plus</v-icon>
              </v-btn>
            </template>
            <span>Asignar adenda</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-btn class="mt-4" block color="primary" :disabled="selected.length === 0" @click="abrirDialogo(selected)">
        <v-icon left>mdi-file-plus</v-icon>
        Asignar adenda a puestos seleccionados
      </v-btn>
    </div>

    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>Crear adenda</v-card-title>
        <v-card-text>
          <v-alert type="info" text dense>
            Se creará una adenda para {{ puestosParaAsignar.length }} {{ puestosParaAsignar.length === 1 ? 'puesto' : 'puestos' }}.
          </v-alert>
          <v-list dense class="mb-4 py-0">
            <v-list-item v-for="puesto in puestosParaAsignar" :key="puesto.id_empleado_puesto" class="px-0">
              <v-list-item-content>
                <v-list-item-title>
                  <span v-if="puesto.codigo_empleado">[{{ puesto.codigo_empleado }}] </span>{{ nombreCompleto(puesto) || 'Empleado sin nombre' }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ puesto.nombre_puesto || 'Puesto no disponible' }} · {{ periodo(puesto) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-select v-model="idTipoAdenda" :items="tiposAdenda" item-value="id_empleado_adenda_tipo" item-text="nombre" label="Tipo de adenda" outlined dense />
          <v-select v-model="idMotivoAdenda" :items="motivosAdenda" item-value="id_empleado_adenda_motivo" item-text="nombre" label="Motivo de adenda" outlined dense />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="cerrarDialogo">Cancelar</v-btn>
          <v-btn color="red" text :loading="saving" :disabled="!idTipoAdenda || !idMotivoAdenda" @click="asignar">
            Asignar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue'

export default {
  components: { VAlertDialog },
  data: () => ({
    loading: false,
    saving: false,
    items: [],
    selected: [],
    areas: [],
    puestos: [],
    tiposAdenda: [],
    motivosAdenda: [],
    dialog: false,
    puestosParaAsignar: [],
    idTipoAdenda: null,
    idMotivoAdenda: null,
    generos: [
      { text: 'Femenino', value: 0 },
      { text: 'Masculino', value: 1 }
    ],
    search: { codigoEmpleado: '', nombre: '', apellidoPaterno: '', apellidoMaterno: '', rfc: '', genero: null, anio: null, tipoPuestos: [], puestos: [] },
    headers: [
      { text: '# Empleado', value: 'codigo_empleado' },
      { text: 'Nombre', value: 'nombre_completo' },
      { text: 'Puesto', value: 'nombre_puesto' },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' }
    ]
  }),
  computed: {
    years () {
      const maxYear = new Date().getFullYear() + 1
      return Array.from({ length: maxYear - 2026 + 1 }, (_, index) => 2026 + index)
    },
    puestosFiltrados () {
      if (!this.search.tipoPuestos.length) return this.puestos
      return this.puestos.filter(puesto => this.search.tipoPuestos.includes(puesto.id_rh_area))
    }
  },
  mounted () {
    this.cargarCatalogos()
    this.getItems()
  },
  methods: {
    async cargarCatalogos () {
      try {
        const [areas, puestos, tipos, motivos] = await Promise.all([
          axios.get('/RHCatalogos/ListarRHAreas'),
          axios.get('/RecursosHumanos/ListarPuestos'),
          axios.get('/RecursosHumanos/ListarEmpleadoAdendaTipos'),
          axios.get('/RecursosHumanos/ListarEmpleadoAdendaMotivos')
        ])
        this.areas = areas.data || []
        this.puestos = puestos.data || []
        this.tiposAdenda = tipos.data || []
        this.motivosAdenda = motivos.data || []
      } catch (error) {
        this.mostrarError('No se pudieron cargar los catálogos de adendas.')
      }
    },
    getUrl () {
      const url = new URL('http://localhost/RecursosHumanos/ListarEmpleadosPuestosAdendasDisponibles')
      const search = this.search

      if (search.codigoEmpleado) url.searchParams.append('codigo_empleado', search.codigoEmpleado)
      if (search.nombre) url.searchParams.append('nombre', search.nombre)
      if (search.apellidoPaterno) url.searchParams.append('apellido_paterno', search.apellidoPaterno)
      if (search.apellidoMaterno) url.searchParams.append('apellido_materno', search.apellidoMaterno)
      if (search.rfc) url.searchParams.append('rfc', search.rfc)
      if (search.genero !== null && search.genero !== undefined && search.genero !== '') url.searchParams.append('genero', search.genero)
      if (search.anio) url.searchParams.append('anio', search.anio)
      search.tipoPuestos.forEach(id => url.searchParams.append('ids_rh_areas', id))
      search.puestos.forEach(id => url.searchParams.append('ids_puestos', id))

      return url.href.replace('http://localhost', '')
    },
    async getItems () {
      this.loading = true
      try {
        const response = await axios.get(this.getUrl())
        this.items = response.data || []
        this.selected = []
      } catch (error) {
        this.mostrarError(this.mensajeError(error, 'No se pudieron obtener los puestos candidatos.'))
      } finally {
        this.loading = false
      }
    },
    nombreCompleto (item) {
      return [item.nombre, item.apellido_paterno, item.apellido_materno].filter(Boolean).join(' ')
    },
    periodo (item) {
      return (item.fecha_desde || 'N/D') + ' - ' + (item.fecha_hasta || 'Indefinido')
    },
    abrirDialogo (puestos) {
      this.puestosParaAsignar = [...puestos]
      this.idTipoAdenda = null
      this.idMotivoAdenda = null
      this.dialog = true
    },
    cerrarDialogo () {
      this.dialog = false
      this.puestosParaAsignar = []
      this.idTipoAdenda = null
      this.idMotivoAdenda = null
    },
    async asignar () {
      if (!this.idTipoAdenda || !this.idMotivoAdenda || !this.puestosParaAsignar.length) return
      this.saving = true
      try {
        if (this.puestosParaAsignar.length === 1) {
          await axios.post('/RecursosHumanos/CrearEmpleadoPuestoAdenda', {
            id_empleado_puesto: this.puestosParaAsignar[0].id_empleado_puesto,
            id_empleado_adenda_tipo: this.idTipoAdenda,
            id_empleado_adenda_motivo: this.idMotivoAdenda
          })
        } else {
          await axios.post('/RecursosHumanos/AsignarEmpleadoPuestoAdendasMasivo', {
            id_empleado_adenda_tipo: this.idTipoAdenda,
            id_empleado_adenda_motivo: this.idMotivoAdenda,
            ids_empleado_puesto: this.puestosParaAsignar.map(puesto => puesto.id_empleado_puesto)
          })
        }
        this.cerrarDialogo()
        await this.getItems()
      } catch (error) {
        this.mostrarError(this.mensajeError(error, 'No se pudieron crear las adendas.'))
      } finally {
        this.saving = false
      }
    },
    mensajeError (error, fallback) {
      const data = error && error.response && error.response.data
      return (data && (data.msg || data.message || data.title)) || fallback
    },
    mostrarError (mensaje) {
      this.$refs.alert.setMessage('', mensaje)
      this.$refs.alert.open()
    }
  }
}
</script>
